/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeSchematicBuildPlanDto,
  ApiEnvelopeSchematicDeletedDto,
  ApiEnvelopeSchematicListResponse,
  ApiEnvelopeSchematicSummaryDto,
  SchematicBuildSiteRequest,
  SchematicsGetBuildPlanParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type schematicsListResponse200 = {
  data: ApiEnvelopeSchematicListResponse
  status: 200
}

export type schematicsListResponse401 = {
  data: ApiEnvelopeSchematicListResponse
  status: 401
}

export type schematicsListResponseSuccess = (schematicsListResponse200) & {
  headers: Headers;
};
export type schematicsListResponseError = (schematicsListResponse401) & {
  headers: Headers;
};

export type schematicsListResponse = (schematicsListResponseSuccess | schematicsListResponseError)

export const getSchematicsListUrl = () => {




  return `/api/schematics`
}

export const useSchematicsListHook = (): ( options?: RequestInit) => Promise<schematicsListResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getSchematicsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type schematicsGetBuildPlanResponse200 = {
  data: ApiEnvelopeSchematicBuildPlanDto
  status: 200
}

export type schematicsGetBuildPlanResponse404 = {
  data: ApiEnvelopeSchematicBuildPlanDto
  status: 404
}

export type schematicsGetBuildPlanResponseSuccess = (schematicsGetBuildPlanResponse200) & {
  headers: Headers;
};
export type schematicsGetBuildPlanResponseError = (schematicsGetBuildPlanResponse404) & {
  headers: Headers;
};

export type schematicsGetBuildPlanResponse = (schematicsGetBuildPlanResponseSuccess | schematicsGetBuildPlanResponseError)

export const getSchematicsGetBuildPlanUrl = (id: string,
    params?: SchematicsGetBuildPlanParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/schematics/${id}/plan?${stringifiedParams}` : `/api/schematics/${id}/plan`
}

export const useSchematicsGetBuildPlanHook = (): (id: string,
    params?: SchematicsGetBuildPlanParams, options?: RequestInit) => Promise<schematicsGetBuildPlanResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: SchematicsGetBuildPlanParams, options?: RequestInit) => {

        return customFetcher(getSchematicsGetBuildPlanUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type schematicsSetBuildSiteResponse200 = {
  data: ApiEnvelopeSchematicSummaryDto
  status: 200
}

export type schematicsSetBuildSiteResponse404 = {
  data: ApiEnvelopeSchematicSummaryDto
  status: 404
}

export type schematicsSetBuildSiteResponseSuccess = (schematicsSetBuildSiteResponse200) & {
  headers: Headers;
};
export type schematicsSetBuildSiteResponseError = (schematicsSetBuildSiteResponse404) & {
  headers: Headers;
};

export type schematicsSetBuildSiteResponse = (schematicsSetBuildSiteResponseSuccess | schematicsSetBuildSiteResponseError)

export const getSchematicsSetBuildSiteUrl = (id: string,) => {




  return `/api/schematics/${id}/build-site`
}

export const useSchematicsSetBuildSiteHook = (): (id: string,
    schematicBuildSiteRequest?: SchematicBuildSiteRequest, options?: RequestInit) => Promise<schematicsSetBuildSiteResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    schematicBuildSiteRequest?: SchematicBuildSiteRequest, options?: RequestInit) => {

        return customFetcher(getSchematicsSetBuildSiteUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schematicBuildSiteRequest)
  }
);
      }
  }


export type schematicsDeleteResponse200 = {
  data: ApiEnvelopeSchematicDeletedDto
  status: 200
}

export type schematicsDeleteResponse404 = {
  data: ApiEnvelopeSchematicDeletedDto
  status: 404
}

export type schematicsDeleteResponseSuccess = (schematicsDeleteResponse200) & {
  headers: Headers;
};
export type schematicsDeleteResponseError = (schematicsDeleteResponse404) & {
  headers: Headers;
};

export type schematicsDeleteResponse = (schematicsDeleteResponseSuccess | schematicsDeleteResponseError)

export const getSchematicsDeleteUrl = (id: string,) => {




  return `/api/schematics/${id}`
}

export const useSchematicsDeleteHook = (): (id: string, options?: RequestInit) => Promise<schematicsDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getSchematicsDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


